import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { AgentService } from '../services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: '',
  template: '',
})
export class AgentHierarchyBranchSearchHandler
  extends BaseSearchComponent<AgentService>
  implements OnInit, AfterViewInit
{
  public searchName: string;
  public isAdvanceSearchDisplayed: boolean;
  public item: any;
  public searchCriteriaData;

  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
  }

  ngOnInit() {
    this.searchCriteriaData = {
      'BranchDO.agentId': null,
      'BranchDO.agentName': null,
    };
  }

  ngAfterViewInit() {
    // this.changeDetector.detectChanges();
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = 'Search - Branch';
    return header;
  }
}
